import { tr } from "../../lib/i18n";

const STAGE_LABELS = [["before", "While they're here", "Ready if they can't decide"], ["after", "After they're gone", "Every next step, laid out"]];

export const StageCompare = ({ c, heading = true }) => (
  <section className="mb-10" data-testid={`compare-stages${heading ? "" : `-${c.slug}`}`}>
    {heading && <>
      <h2 className="font-serif text-2xl">Before and after — what {c.name} doesn't plan for</h2>
      <p className="mt-1 text-sm text-muted-foreground">The two moments families call us about: when someone has to speak for a parent, and the weeks after a death.</p>
    </>}
    <div className="mt-5 grid md:grid-cols-2 gap-4">
      {STAGE_LABELS.map(([k, eyebrow, title], i) => (
        <div key={k} className={`rounded-2xl border p-5 ${i === 0 ? "border-primary/40 bg-primary/5" : "border-border bg-card"}`} data-testid={`compare-stage-${k}${heading ? "" : `-${c.slug}`}`}>
          <div className="text-[10px] uppercase tracking-[0.2em] font-mono text-primary">{i + 1} · {tr(eyebrow)}</div>
          <h3 className="font-serif text-xl mt-1">{tr(title)}</h3>
          <dl className="mt-4 space-y-3">
            {c.stages[k].map(([label, hv, them]) => (
              <div key={label} className="text-sm">
                <dt className="font-medium">{tr(label)}</dt>
                <dd className="mt-0.5 text-primary">HearthVault: <span className="text-foreground">{tr(hv)}</span></dd>
                <dd className="text-muted-foreground">{c.name}: {tr(them)}</dd>
              </div>
            ))}
          </dl>
        </div>
      ))}
    </div>
  </section>
);
